import {
  CHANGE_PAGE,
  CHANGE_SELECTION_DATA,
  GET_PARTICIPANTS_ASYNC,
  GET_PARTICIPANTS_INFO_ASYNC,
  SEARCH_PARTICIPANTS_INFO_ASYNC,
  VALIDATE_SETUP_STEP,
} from './constants'

export const getParticipantsInfoSuccess = (data) => ({
  type: GET_PARTICIPANTS_INFO_ASYNC.SUCCESS,
  payload: { data },
})
export const getParticipantsInfoError = (error) => ({
  type: GET_PARTICIPANTS_INFO_ASYNC.ERROR,
  error,
})

export const validateStepFields = () => ({ type: VALIDATE_SETUP_STEP })

export const getParticipantsSuccess = (data) => ({
  type: GET_PARTICIPANTS_ASYNC.SUCCESS,
  payload: { data },
})
export const getParticipantsError = (error) => ({
  type: GET_PARTICIPANTS_ASYNC.ERROR,
  error,
})

export const searchParticipantsInfoSuccess = (data) => ({
  type: SEARCH_PARTICIPANTS_INFO_ASYNC.SUCCESS,
  payload: { data },
})
export const searchParticipantsInfoError = (error) => ({
  type: SEARCH_PARTICIPANTS_INFO_ASYNC.ERROR,
  error,
})

const changePage = (page) => ({ type: CHANGE_PAGE, payload: { page } })
const changeSelectionData = (field, value) => ({
  type: CHANGE_SELECTION_DATA,
  payload: { field, value },
})

export default {
  // to props
  validateStepFields,
  changePage,
  changeSelectionData,
}
